<template v-if="props.selectedImageState?.photoList">
  <div class="flex flex-col gap-2">
    <ImageButton :elevate-on-hover="false" :small-on-mobile="false" @click.prevent="select(null)" :selected="isSelected(null)">
      <div class="bg-white checkerboard !w-full !h-full"></div>
    </ImageButton>

    <div v-if="props.isLoading" class="!h-16 !w-16 !rounded-lg !bg-secondary animate-pulse"></div>
    <ImageButton v-if="props.availableBackgrounds.length > 0" :elevate-on-hover="false" :small-on-mobile="false" :selected="isSelected(props.availableBackgrounds[0]?.image_url)" @click.prevent="select(props.availableBackgrounds[0]?.image_url)">
      <Image :src="props.availableBackgrounds[0]?.thumbnail_url" alt="Background image" img-classes="object-cover !w-16 !h-16 bg-white checkerboard" />
    </ImageButton>
  </div>
  <div class="flex flex-col gap-2">
    <!-- upload background button -->
    <ImageButton :elevate-on-hover="false" :small-on-mobile="false" @click="uploadFile">
      <div class="bg-white hover:bg-secondary h-full flex justify-center items-center">
        <AddIcon />
      </div>
    </ImageButton>

    <div v-if="props.isLoading" class="!h-16 !w-16 !rounded-lg !bg-secondary animate-pulse"></div>
    <ImageButton v-if="props.availableBackgrounds.length > 0" :elevate-on-hover="false" :small-on-mobile="false" :selected="isSelected(props.availableBackgrounds[1]?.image_url)" @click.prevent="select(props.availableBackgrounds[1]?.image_url)">
      <Image :src="props.availableBackgrounds[1]?.thumbnail_url" alt="Example image" img-classes="object-cover !w-16 !h-16 bg-white checkerboard" />
    </ImageButton>
  </div>

  <template v-if="props.isLoading">
    <div v-for="i in 3" :key="i" class="flex flex-col gap-2">
      <div v-for="x in 2" :key="x" class="!h-16 !w-16 !rounded-lg !bg-secondary animate-pulse"></div>
    </div>
  </template>

  <div v-else class="flex flex-col gap-2" v-for="tuple in tuples">
    <ImageButton :elevate-on-hover="false" :small-on-mobile="false" v-for="photo in tuple" :selected="isSelected(photo.image_url)" @click.prevent="select(photo.image_url)" :key="photo.thumbnail_url">
      <Image :src="photo.thumbnail_url" alt="Background image" img-classes="object-cover !w-16 !h-16 bg-white checkerboard" />
    </ImageButton>
  </div>
</template>

<script setup lang="ts">
import { Background, originalUrl } from "@/modules/internal_api/image";
import { Image, ImageButton, AddIcon } from "prism";
import { computed } from "vue";
import { useEditorStore } from "@/stores/editor_store";
import { rbgEditorApplyBackgroundImageV100 } from "kaleido-event-tracker";

export interface PhotoTilesMobileProps {
  isLoading: boolean;
  selectedImageState: any;
  availableBackgrounds: Background[];
}

const props = defineProps<PhotoTilesMobileProps>();
const store = useEditorStore();

const tuples = computed(() => {
  let availableBackgrounds = props.availableBackgrounds.slice(); // slice to not alter the original array
  availableBackgrounds.shift(); // remove first two entries as they are added to the tiles directly
  availableBackgrounds.shift();
  var splicePos = 0; // Because of the tuple ordering of tiles we need to insert the original image at another position if there is a user uploaded background
  if (props.selectedImageState?.uploadedBackgroundPhotoUrl) {
    splicePos += 2;
    // add the url of the uploaded background to the list
    availableBackgrounds.unshift({
      // add to second position
      id: "0",
      image_url: props.selectedImageState?.uploadedBackgroundPhotoUrl,
      thumbnail_url: props.selectedImageState?.uploadedBackgroundPhotoUrl,
    });
  }
  // add original image
  availableBackgrounds.splice(splicePos, 0, {
    id: "1",
    image_url: originalUrl(store.selectedImage),
    thumbnail_url: originalUrl(store.selectedImage),
  });
  const imageTuples = availableBackgrounds?.reduce(function (r, a, i) {
    // create tuples from the array
    if (i % 2) {
      r[r.length - 1].push(a);
    } else {
      r.push([a]);
    }
    return r;
  }, []);
  return imageTuples;
});

const isSelected = (image_url) => {
  return props.selectedImageState.selectedBackgroundPhotoUrl === image_url;
};

const select = (image_url) => {
  props.selectedImageState.withSnapshot(() => {
    props.selectedImageState.setSelectedBackgroundColor(undefined);
    props.selectedImageState.setSelectedBackgroundPhotoUrl(image_url);
  });

  rbgEditorApplyBackgroundImageV100({ image_id: store.selectedImage.meta.id, background_image_id: image_url });
};

const uploadFile = () => {
  window.onUploadBackgroundFile();
};
</script>
